// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { TripApiConfigurationAreaId } from './TripApiConfigurationAreaId'
import { TripApiConfigurationAreaNavigation } from './TripApiConfigurationAreaNavigation'
import { TripApiConfigurationAreaRoutes } from './TripApiConfigurationAreaRoutes'

const LazyTripApiConfigurationComponent = lazy(
  () => import('./TripApiConfigurationArea'),
)

const TripApiConfigurationComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyTripApiConfigurationComponent />
  </SuspenseLoadingWrapper>
)

export const TripApiConfigurationArea = {
  id: TripApiConfigurationAreaId,
  requiredRight: BoumRight.AREA_TRIP_API_CONFIGURATION,
  NavigationComponent: TripApiConfigurationAreaNavigation,
  route: {
    path: TripApiConfigurationAreaRoutes.route,
    component: TripApiConfigurationComponent,
  },
}
